import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AuthService } from './auth.service';
import { Globals } from '../shared/globals';
import { TranslateService } from '@ngx-translate/core';
import { PaymentHistory } from '../models/payment-history.model';

@Injectable()
export class PaymentsService {
  public translate: TranslateService;
  private paymentsUrl: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private globals: Globals,
    translate: TranslateService
  ) {
    this.translate = translate;
    this.paymentsUrl = globals.apiUrl('ChargingPaymentHistory');
  }

  getChargingPaymentHistory(
    startDate: Date,
    endDate: Date
  ): Promise<PaymentHistory[]> {
    return this.authService
      .getToken()
      .then((result) => {
        const basicToken = 'Basic ' + result;
        return this.http
          .get(
            this.paymentsUrl +
              '?startDate=' +
              startDate.toISOString() +
              '&endDate=' +
              endDate.toISOString(),
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: basicToken,
              },
            }
          )
          .toPromise()
          .then((response) => {
            return response;
          })
          .catch((err) => {
            return err;
          });
      })
      .catch((err) => {
        Promise.reject(err);
      });
  }
}
